var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isMeteredBillingPartiallyReleased
        ? [
            _vm.isShowingInformational
              ? [
                  _vm.usagePercentage > 100
                    ? _c(
                        "owa-message",
                        {
                          attrs: {
                            "icon-style": "solid",
                            "icon-name": "faSkullCrossbones",
                            theme: "danger",
                            type: "flash",
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom":
                                      "var(--spacing-xs)",
                                  },
                                },
                                [
                                  _c("strong", [_vm._v("Dang it.")]),
                                  _vm._v(
                                    "\n            You've used more than the\n            "
                                  ),
                                  _vm.type === "kit"
                                    ? [_vm._v("pageviews")]
                                    : _vm.type === "npm"
                                    ? [_vm._v("npm bandwidth")]
                                    : _vm._e(),
                                  _vm._v(
                                    "\n            allowed for your plan this month.\n          "
                                  ),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm.usagePercentage > 85
                    ? _c(
                        "owa-message",
                        {
                          attrs: {
                            "icon-style": "solid",
                            "icon-name": "faExclamationTriangle",
                            theme: "warning",
                            type: "flash",
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom":
                                      "var(--spacing-xs)",
                                  },
                                },
                                [
                                  _c("strong", [_vm._v("Eek!")]),
                                  _vm._v(
                                    "\n            You're almost over the\n            "
                                  ),
                                  _vm.type === "kit"
                                    ? [_vm._v("pageviews")]
                                    : _vm.type === "npm"
                                    ? [_vm._v("npm bandwidth")]
                                    : _vm._e(),
                                  _vm._v(
                                    "\n            allowed for your plan for this month.\n          "
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom": "0",
                                  },
                                },
                                [
                                  _c(
                                    "site-link",
                                    {
                                      staticClass: "margin-right-md",
                                      attrs: { to: { name: "plans" } },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.$posthog.capture(
                                            "usage:plans_link_click"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Upgrade\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.type === "kit"
                                    ? _c(
                                        "site-link",
                                        {
                                          attrs: {
                                            to: _vm.$docs(
                                              "/web/setup/use-kit",
                                              { hash: "#tune-your-kits" }
                                            ),
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.$posthog.capture(
                                                "usage:tune_your_kits_link_click"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              Learn How to Tune Your Kits\n            "
                                          ),
                                        ]
                                      )
                                    : _vm.type === "npm"
                                    ? _c(
                                        "site-link",
                                        {
                                          attrs: {
                                            to: _vm.$docs(
                                              "/web/dig-deeper/continuous-integration"
                                            ),
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.$posthog.capture(
                                                "usage:tune_your_ci_link_click"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              Learn How to Tune Your CI\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm.usagePercentage > 65
                    ? _c(
                        "owa-message",
                        {
                          attrs: {
                            "icon-style": "solid",
                            "icon-name": "faBlockQuestion",
                            theme: "info",
                            type: "flash",
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom":
                                      "var(--spacing-xs)",
                                  },
                                },
                                [
                                  _c("strong", [_vm._v("Just a heads up.")]),
                                  _vm._v(
                                    "\n            You've used over half of your month's\n            "
                                  ),
                                  _vm.type === "kit"
                                    ? [_vm._v("pageview")]
                                    : _vm.type === "npm"
                                    ? [_vm._v("npm bandwidth")]
                                    : _vm._e(),
                                  _vm._v("\n            limit.\n          "),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom": "0",
                                  },
                                },
                                [
                                  _vm.type === "kit"
                                    ? _c(
                                        "site-link",
                                        {
                                          attrs: {
                                            to: _vm.$docs(
                                              "/web/setup/use-kit",
                                              { hash: "#tune-your-kits" }
                                            ),
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.$posthog.capture(
                                                "usage:tune_your_kits_link_click"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              Learn How to Tune Your Kits\n            "
                                          ),
                                        ]
                                      )
                                    : _vm.type === "npm"
                                    ? _c(
                                        "site-link",
                                        {
                                          attrs: {
                                            to: _vm.$docs(
                                              "/web/dig-deeper/continuous-integration"
                                            ),
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.$posthog.capture(
                                                "usage:tune_your_ci_link_click"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              Learn How to Tune Your CI\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              : _vm._e(),
          ]
        : [
            _vm.isShowingDire &&
            _vm.isServiceDeactivated &&
            _vm.overageUsagePercentage >= 100
              ? [
                  _vm.isMeteredBilling
                    ? _c(
                        "owa-message",
                        {
                          class: {
                            "margin-top-2xl": !_vm.isShowingAllMessageGroups,
                          },
                          attrs: {
                            "icon-style": "solid",
                            "icon-name": "faExclamationTriangle",
                            theme: "danger",
                            title: `You've used your plan's monthly ${_vm.serviceUnitLabel} limit and Metered Billing limit.`,
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom":
                                      "var(--spacing-xs)",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            We've deactivated this service until it resets next month -\n            " +
                                      _vm._s(_vm.deactivationRepercussion) +
                                      ". Increase your overage billing limit to reactivate it immediately.\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom": "0",
                                  },
                                },
                                [
                                  _c("metered-billing-action", {
                                    attrs: { action: "settings" },
                                  }),
                                  _vm._v(" "),
                                  _c("usage-actions", {
                                    attrs: {
                                      "is-showing-upgrade":
                                        _vm.isAllowedToUpgrade,
                                      type: _vm.type,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm.billablePageviewsOverage
                    ? _c(
                        "owa-message",
                        {
                          class: {
                            "margin-top-2xl": !_vm.isShowingAllMessageGroups,
                          },
                          attrs: {
                            "icon-style": "solid",
                            "icon-name": "faExclamationTriangle",
                            theme: "danger",
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c("p", [
                                _c("strong", [
                                  _vm._v(
                                    "You've used your plan's monthly " +
                                      _vm._s(_vm.serviceUnitLabel) +
                                      " limit and have metered overages."
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom":
                                      "var(--spacing-xs)",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            We've deactivated this service until it resets next month - " +
                                      _vm._s(_vm.deactivationRepercussion) +
                                      ".\n            "
                                  ),
                                  _vm.isMeteredBillingFeatureOn
                                    ? _c("span", [
                                        _vm._v(
                                          "You'll also be billed for this month's existing overage charges."
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom": "0",
                                  },
                                },
                                [
                                  !_vm.$dt.isFree &&
                                  _vm.isMeteredBillingFeatureOn
                                    ? _c("metered-billing-action")
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("usage-actions", {
                                    attrs: {
                                      "is-showing-upgrade":
                                        _vm.isAllowedToUpgrade,
                                      type: _vm.type,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _c(
                        "owa-message",
                        {
                          class: {
                            "margin-top-2xl": !_vm.isShowingAllMessageGroups,
                          },
                          attrs: {
                            "icon-style": "solid",
                            "icon-name": "faExclamationTriangle",
                            theme: "danger",
                            title: `You've used your plan's monthly ${_vm.serviceUnitLabel} limit`,
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom":
                                      "var(--spacing-xs)",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            We've deactivated this service until it resets next month -\n            " +
                                      _vm._s(_vm.deactivationRepercussion) +
                                      ".\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom": "0",
                                  },
                                },
                                [
                                  !_vm.$dt.isFree &&
                                  _vm.isMeteredBillingFeatureOn
                                    ? _c("metered-billing-action")
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("usage-actions", {
                                    attrs: {
                                      "is-showing-upgrade":
                                        _vm.isAllowedToUpgrade,
                                      type: _vm.type,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      ),
                ]
              : _vm.isShowingInformational &&
                _vm.isMeteredBilling &&
                _vm.hasSetOverageLimit &&
                _vm.overageUsagePercentage < 100
              ? [
                  _vm.overageUsagePercentage >= 90
                    ? _c(
                        "owa-message",
                        {
                          attrs: {
                            "icon-style": "solid",
                            "icon-name": "faExclamationTriangle",
                            theme: "warning",
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom":
                                      "var(--spacing-xs)",
                                  },
                                },
                                [
                                  _c("strong", [_vm._v("Eek!")]),
                                  _vm._v(
                                    "\n            You're almost at your\n            " +
                                      _vm._s(_vm.serviceUnitLabel) +
                                      "\n            metered billing limit. Increase your overage billing limit to avoid any service interruptions.\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom": "0",
                                  },
                                },
                                [
                                  _c("metered-billing-action", {
                                    attrs: { action: "settings" },
                                  }),
                                  _vm._v(" "),
                                  _c("usage-actions", {
                                    attrs: {
                                      "is-showing-upgrade":
                                        _vm.isAllowedToUpgrade,
                                      type: _vm.type,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm.overageUsagePercentage >= 60
                    ? _c(
                        "owa-message",
                        {
                          attrs: {
                            "icon-style": "solid",
                            "icon-name": "faExclamationTriangle",
                            theme: "warning",
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom":
                                      "var(--spacing-xs)",
                                  },
                                },
                                [
                                  _c("strong", [_vm._v("Heads up!")]),
                                  _vm._v(
                                    "\n            You've used over half of your\n            " +
                                      _vm._s(_vm.serviceUnitLabel) +
                                      "\n            metered billing limit. You can increase the overage billing limit to avoid any service interruptions.\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom": "0",
                                  },
                                },
                                [
                                  _c("metered-billing-action", {
                                    attrs: { action: "settings" },
                                  }),
                                  _vm._v(" "),
                                  _c("usage-actions", {
                                    attrs: {
                                      "is-showing-upgrade":
                                        _vm.isAllowedToUpgrade,
                                      type: _vm.type,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm.usagePercentage >= 100
                    ? _c(
                        "owa-message",
                        {
                          attrs: {
                            "icon-style": "solid",
                            "icon-name": "faCircleInfo",
                            theme: "info",
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom":
                                      "var(--spacing-xs)",
                                  },
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      " You've used your plan's monthly " +
                                        _vm._s(_vm.serviceUnitLabel)
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n            and will be charged for any metered billing overages until " +
                                      _vm._s(
                                        _vm.overagesTerminationMomentLabel
                                      ) +
                                      ".\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom": "0",
                                  },
                                },
                                [
                                  _c("metered-billing-action", {
                                    attrs: { action: "settings" },
                                  }),
                                  _vm._v(" "),
                                  _c("usage-actions", {
                                    attrs: {
                                      "is-showing-upgrade":
                                        _vm.isAllowedToUpgrade,
                                      type: _vm.type,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm.usagePercentage >= 90
                    ? _c(
                        "owa-message",
                        {
                          attrs: {
                            "icon-style": "solid",
                            "icon-name": "faCircleInfo",
                            theme: "info",
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom":
                                      "var(--spacing-xs)",
                                  },
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      "You're almost over your plan's monthly " +
                                        _vm._s(_vm.serviceUnitLabel) +
                                        " limit"
                                    ),
                                  ]),
                                  _vm._v(
                                    ". If your use exceeds that, you will be charged for any\n            metered billing overages until " +
                                      _vm._s(
                                        _vm.overagesTerminationMomentLabel
                                      ) +
                                      ".\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom": "0",
                                  },
                                },
                                [
                                  _c("metered-billing-action", {
                                    attrs: { action: "settings" },
                                  }),
                                  _vm._v(" "),
                                  _c("usage-actions", {
                                    attrs: {
                                      "is-showing-upgrade":
                                        _vm.isAllowedToUpgrade,
                                      type: _vm.type,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm.usagePercentage >= 60
                    ? _c(
                        "owa-message",
                        {
                          attrs: {
                            "icon-style": "solid",
                            "icon-name": "faCircleInfo",
                            theme: "info",
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom":
                                      "var(--spacing-xs)",
                                  },
                                },
                                [
                                  _c("strong", [_vm._v("Heads up!")]),
                                  _vm._v(
                                    "\n            You've used over half of your Plan's monthly\n            " +
                                      _vm._s(_vm.serviceUnitLabel) +
                                      "\n            limit.\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom": "0",
                                  },
                                },
                                [
                                  _c("metered-billing-action", {
                                    attrs: { action: "settings" },
                                  }),
                                  _vm._v(" "),
                                  _c("usage-actions", {
                                    attrs: {
                                      "is-showing-upgrade": false,
                                      type: _vm.type,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              : _vm.isShowingInformational &&
                _vm.isMeteredBilling &&
                !_vm.hasSetOverageLimit
              ? [
                  _vm.usagePercentage >= 1000
                    ? _c(
                        "owa-message",
                        {
                          attrs: {
                            "icon-style": "solid",
                            "icon-name": "faExclamationTriangle",
                            theme: "warning",
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom":
                                      "var(--spacing-xs)",
                                  },
                                },
                                [
                                  _c("strong", [_vm._v("Heads up!")]),
                                  _vm._v(
                                    "\n            You've used over 10x of your plan's monthly " +
                                      _vm._s(_vm.serviceUnitLabel) +
                                      " limit.\n            "
                                  ),
                                  _vm.isMeteredBillingFeatureOn
                                    ? [
                                        _vm._v(
                                          "You will be charged for any metered billing overages."
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom": "0",
                                  },
                                },
                                [
                                  _c("metered-billing-action", {
                                    attrs: { action: "settings" },
                                  }),
                                  _vm._v(" "),
                                  _c("usage-actions", {
                                    attrs: {
                                      "is-showing-upgrade":
                                        _vm.isAllowedToUpgrade,
                                      type: _vm.type,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm.usagePercentage >= 100
                    ? _c(
                        "owa-message",
                        {
                          attrs: {
                            "icon-style": "solid",
                            "icon-name": "faCircleInfo",
                            theme: "info",
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom":
                                      "var(--spacing-xs)",
                                  },
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      " You've used your plan's monthly " +
                                        _vm._s(_vm.serviceUnitLabel)
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n            and will be charged for any metered billing overages until " +
                                      _vm._s(
                                        _vm.overagesTerminationMomentLabel
                                      ) +
                                      ".\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom": "0",
                                  },
                                },
                                [
                                  _c("metered-billing-action", {
                                    attrs: { action: "settings" },
                                  }),
                                  _vm._v(" "),
                                  _c("usage-actions", {
                                    attrs: {
                                      "is-showing-upgrade":
                                        _vm.isAllowedToUpgrade,
                                      type: _vm.type,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm.usagePercentage >= 90
                    ? _c(
                        "owa-message",
                        {
                          attrs: {
                            "icon-style": "solid",
                            "icon-name": "faCircleInfo",
                            theme: "info",
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom":
                                      "var(--spacing-xs)",
                                  },
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      "You're almost over your plan's monthly " +
                                        _vm._s(_vm.serviceUnitLabel) +
                                        " limit"
                                    ),
                                  ]),
                                  _vm._v(
                                    ". If your use exceeds that, you will be charged for any\n            metered billing overages until " +
                                      _vm._s(
                                        _vm.overagesTerminationMomentLabel
                                      ) +
                                      ".\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom": "0",
                                  },
                                },
                                [
                                  _c("metered-billing-action", {
                                    attrs: { action: "settings" },
                                  }),
                                  _vm._v(" "),
                                  _c("usage-actions", {
                                    attrs: {
                                      "is-showing-upgrade":
                                        _vm.isAllowedToUpgrade,
                                      type: _vm.type,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm.usagePercentage >= 60
                    ? _c(
                        "owa-message",
                        {
                          attrs: {
                            "icon-style": "solid",
                            "icon-name": "faCircleInfo",
                            theme: "info",
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom":
                                      "var(--spacing-xs)",
                                  },
                                },
                                [
                                  _c("strong", [_vm._v("Heads up!")]),
                                  _vm._v(
                                    "\n            You've used over half of your Plan's monthly\n            " +
                                      _vm._s(_vm.serviceUnitLabel) +
                                      "\n            limit.\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom": "0",
                                  },
                                },
                                [
                                  _c("metered-billing-action", {
                                    attrs: { action: "settings" },
                                  }),
                                  _vm._v(" "),
                                  _c("usage-actions", {
                                    attrs: {
                                      "is-showing-upgrade": false,
                                      type: _vm.type,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              : _vm.isShowingInformational &&
                !_vm.isMeteredBilling &&
                _vm.usagePercentage < 100
              ? [
                  _vm.usagePercentage >= 90
                    ? _c(
                        "owa-message",
                        {
                          attrs: {
                            "icon-style": "solid",
                            "icon-name": "faExclamationTriangle",
                            theme: "warning",
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom":
                                      "var(--spacing-xs)",
                                  },
                                },
                                [
                                  _c("strong", [_vm._v("Eek!")]),
                                  _vm._v(
                                    " You're almost over your plan's monthly " +
                                      _vm._s(_vm.serviceUnitLabel) +
                                      " limit.\n            "
                                  ),
                                  !_vm.$dt.isFree &&
                                  _vm.isMeteredBillingFeatureOn
                                    ? [
                                        _vm._v(
                                          "Enable metered billing to avoid any service interruptions."
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom": "0",
                                  },
                                },
                                [
                                  !_vm.$dt.isFree &&
                                  _vm.isMeteredBillingFeatureOn
                                    ? _c("metered-billing-action")
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("usage-actions", {
                                    attrs: {
                                      "is-showing-upgrade":
                                        _vm.isAllowedToUpgrade,
                                      type: _vm.type,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm.usagePercentage >= 60
                    ? _c(
                        "owa-message",
                        {
                          attrs: {
                            "icon-style": "solid",
                            "icon-name": "faCircleInfo",
                            theme: "info",
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom":
                                      "var(--spacing-xs)",
                                  },
                                },
                                [
                                  _c("strong", [_vm._v("Heads up!")]),
                                  _vm._v(
                                    "\n            You've used over half of your Plan's monthly\n            " +
                                      _vm._s(_vm.serviceUnitLabel) +
                                      "\n            limit.\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "--paragraph-margin-bottom": "0",
                                  },
                                },
                                [
                                  _c("usage-actions", {
                                    attrs: {
                                      "is-showing-upgrade": false,
                                      type: _vm.type,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }